import Box from '@mui/material/Box';
import PhBookmarkSimpleSvg from '../../../assets/svg-fc/PhBookmarkSimpleSvg';
import PhFillBookmarkSimpleSvg from '../../../assets/svg-fc/PhFillBookmarkSimpleSvg';
import { UI_TOKENS } from '../../../constants/designTokens';

interface iSaveFilterButtonProps {
  onClick: () => void;
  saving?: boolean;
  disabled?: boolean;
}

const SaveFilterButton = ({ onClick, saving = false, disabled = false }: iSaveFilterButtonProps) => {
  const saved = disabled && !saving;
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      disabled={saving || disabled}
      title={saving ? 'Saving' : saved ? 'Filters saved' : 'Save filters'}
      aria-label={saving ? 'Saving' : saved ? 'Filters saved' : 'Save filters'}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 28,
        height: 28,
        flexShrink: 0,
        padding: 0,
        border: 'none',
        borderRadius: '50%',
        background: 'transparent',
        color: UI_TOKENS.sage600,
        cursor: 'pointer',
        '&:hover:not(:disabled)': { bgcolor: '#F2F5F1' },
        '&:disabled': { cursor: 'default', opacity: saving ? 0.6 : 1 },
        '&:focus, &:focus-visible': { outline: 'none' },
      }}
    >
      {saved ? <PhFillBookmarkSimpleSvg size={16} /> : <PhBookmarkSimpleSvg size={16} />}
    </Box>
  );
};

export default SaveFilterButton;
